import { BadgeId } from '../../types';
import { BadgeAssetName } from './names';

export const badgeAssets: {[k in BadgeId]: BadgeAssetName} = {
  trainedInGrimroot: 'badge_trained_in_grimroot',
  magicInstrumentCollector: 'badge_magic_instrument_collector',
  escapedBandits: 'badge_escaped_bandits',
  escapedWaterSpirit: 'badge_escaped_water_spirit',
};
